import React, { useEffect, useMemo, useState } from 'react'
import { request } from 'meinian-package/src/utils'
import { useRequest } from 'ahooks'
import Empty from 'meinian-package/src/baseComponent/empty'
import { isHiddenStyleSourcePlatform } from 'component/filter/platform'
import DesignList, { Template } from './designList'
import './index.less'

const list = [
  { title: '最近访问', value: 'recent' },
  { title: '时间', value: 'time' },
  { title: '品类', value: 'category' },
  { title: '设计要素', value: 'design' },
  { title: '色系', value: 'color' },
  { title: '来源', value: 'source' },
]

const urlList = {
  recent: '/zhikuan/intellect-classify/recent-list',
  source: '/zhikuan/intellect-classify/source-list',
  time: '/zhikuan/intellect-classify/time-list',
  category: '/zhikuan/intellect-classify/category-list',
  design: '/zhikuan/intellect-classify/design-element-list',
  color: '/zhikuan/intellect-classify/color-list'
}

const filterList = {
  time: [{ label: '采集时间', value: 1 }, { label: '上新时间', value: 2 }],
  category: [{ label: '一级品类', value: 1 }, { label: '二级品类', value: 2 }],
  color: [{ label: '一级颜色', value: 1 }, { label: '二级颜色', value: 2 }],
  design: [
    { label: '风格', value: 1 },
    { label: '图案', value: 2 },
    { label: '面料', value: 3 },
    { label: '辅料', value: 4 },
    { label: '工艺', value: 5 },
    { label: '领型', value: 6 },
    { label: '廓形', value: 7 }
  ],
}

const hiddenSourceNames = ['小红书', '知小红']

const isHiddenSourceItem = (item = {}) => {
  return isHiddenStyleSourcePlatform(item.platformId) || hiddenSourceNames.some(name => (
    item.rootClassifyName?.includes(name) || item.classifyName?.includes(name)
  ))
}

export default ({ params }) => {
  return <div className="meinian-home-intelligent">
    <div className="content" style={{ marginTop: '10px' }}>
      {params.gender ? <>
        {
        list.map(v => (v.value === 'design' && params.gender !== '鞋靴' ? <DesignList
          key={v.value}
          title={v.title}
          titleValue={v.value}
          params={params}
        /> : <List
          key={v.value}
          title={v.title}
          titleValue={v.value}
          params={params}
        />))
      }
      </> : <Empty type="tag" />}
    </div>
  </div>
}

const List = (props) => {
  const { title, titleValue, params } = props
  const [listParams, setListParams] = useState()

  useEffect(() => {
    if (titleValue === 'design' && params.gender === '鞋靴') {
      setListParams(pre => ({ ...pre, classifyType: 8 }))
    } else if (titleValue !== 'recent') {
      setListParams(pre => ({ ...pre, classifyType: 1 }))
    } else {
      setListParams({})
    }
  }, [JSON.stringify(params)])

  const { data: dataList, loading, run } = useRequest(async () => {
    const result = await request.post(urlList[titleValue], { ...params, ...listParams })
    return result
  }, {
    manual: true,
    refreshDeps: [listParams],
  })

  useEffect(() => {
    if (listParams) {
      run()
    }
  }, [listParams])

  const visibleDataList = useMemo(() => {
    if (titleValue !== 'source') return dataList
    return dataList?.filter(item => !isHiddenSourceItem(item))
  }, [dataList, titleValue])

  return <Template
    filterOptions={filterList?.[titleValue]}
    filterValue={listParams?.classifyType}
    filterOnChange={val => setListParams(pre => ({ ...pre, classifyType: val }))}
    title={title}
    titleValue={titleValue}
    params={params}
    loading={loading}
    dataList={visibleDataList}
  />
}
